var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRecipients01 = function SvgRecipients01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "recipients-01_svg2__a",
    x1: 54.06,
    x2: 225.35,
    y1: 216.7,
    y2: 72.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#recipients-01_svg2__a",
    id: "recipients-01_svg2__b",
    x1: -5.19,
    x2: 166.1,
    y1: 146.12,
    y2: 2.31
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#recipients-01_svg2__a",
    id: "recipients-01_svg2__c",
    x1: 34.42,
    x2: 205.71,
    y1: 193.3,
    y2: 49.49
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#recipients-01_svg2__a",
    id: "recipients-01_svg2__d",
    x1: 73.99,
    x2: 245.28,
    y1: 240.44,
    y2: 96.62
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#recipients-01_svg2__a",
    id: "recipients-01_svg2__e",
    x1: 14.74,
    x2: 186.03,
    y1: 169.86,
    y2: 26.05
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#recipients-01_svg2__a",
    id: "recipients-01_svg2__f",
    x1: 54.35,
    x2: 225.64,
    y1: 217.04,
    y2: 73.23
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#recipients-01_svg2__a",
    id: "recipients-01_svg2__g",
    x1: 55.99,
    x2: 227.28,
    y1: 218.99,
    y2: 75.18
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#recipients-01_svg2__a",
    id: "recipients-01_svg2__h",
    x1: 24.89,
    x2: 196.19,
    y1: 181.96,
    y2: 38.15
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#recipients-01_svg2__a",
    id: "recipients-01_svg2__i",
    x1: -34.36,
    x2: 136.94,
    y1: 111.38,
    y2: -32.43
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#recipients-01_svg2__a",
    id: "recipients-01_svg2__j",
    x1: -34,
    x2: 137.3,
    y1: 111.82,
    y2: -32
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#recipients-01_svg2__a",
    id: "recipients-01_svg2__k",
    x1: -13.32,
    x2: 157.97,
    y1: 136.44,
    y2: -7.37
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#recipients-01_svg2__a",
    id: "recipients-01_svg2__l",
    x1: -1.21,
    x2: 170.09,
    y1: 150.87,
    y2: 7.06
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#recipients-01_svg2__a",
    id: "recipients-01_svg2__m",
    x1: 19.81,
    x2: 191.11,
    y1: 175.9,
    y2: 32.09
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96.87 156.25h6.25V200h-6.25z",
    style: {
      fill: "url(#recipients-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.25 56.25v3.12c0 10.35 8.4 18.74 18.75 18.75 10.35-.01 18.74-8.4 18.75-18.75v-3.12c0-10.36-8.39-18.75-18.75-18.75s-18.75 8.39-18.75 18.75m6.25 0c0-6.9 5.6-12.5 12.5-12.5s12.5 5.6 12.5 12.5v3.12c0 6.9-5.6 12.5-12.5 12.5s-12.5-5.6-12.5-12.5z",
    style: {
      fill: "url(#recipients-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.75 81.25h-37.5c-8.63.01-15.61 7-15.63 15.63v42.19c0 6.04 4.9 10.94 10.94 10.94 1.68 0 3.26-.41 4.69-1.09v51.09h6.25v-90.63h-6.25v29.69a4.69 4.69 0 0 1-9.38 0V96.88c0-5.18 4.2-9.38 9.38-9.38h37.5c5.18 0 9.38 4.2 9.38 9.38v42.19a4.69 4.69 0 0 1-9.38 0v-29.69h-6.25v90.63h6.25v-51.09c1.43.68 3 1.09 4.69 1.09 6.04 0 10.94-4.9 10.94-10.94V96.88c-.01-8.63-7-15.61-15.63-15.63",
    style: {
      fill: "url(#recipients-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.25 146.88h6.25v43.75h-6.25z",
    style: {
      fill: "url(#recipients-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.63 50c.01 10.35 8.4 18.74 18.75 18.75 10.35-.01 18.74-8.4 18.75-18.75v-3.12c0-10.36-8.39-18.75-18.75-18.75s-18.75 8.39-18.75 18.75zm6.24-3.13c0-6.9 5.6-12.5 12.5-12.5s12.5 5.6 12.5 12.5v3.12c0 6.9-5.6 12.5-12.5 12.5s-12.5-5.6-12.5-12.5z",
    style: {
      fill: "url(#recipients-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.12 71.88h-37.5c-3.81 0-7.48 1.39-10.34 3.91l4.14 4.69a9.3 9.3 0 0 1 6.2-2.34h37.5c5.18 0 9.38 4.2 9.38 9.38v42.19a4.69 4.69 0 0 1-9.38 0v-29.69h-6.25v90.63h6.25v-51.09c1.43.68 3 1.09 4.69 1.09 6.04 0 10.94-4.9 10.94-10.94V87.52c-.01-8.63-7-15.61-15.62-15.62Z",
    style: {
      fill: "url(#recipients-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.63 100h6.25v90.63h-6.25z",
    style: {
      fill: "url(#recipients-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 146.88h6.25v43.75H37.5z",
    style: {
      fill: "url(#recipients-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.63 68.75c10.35-.01 18.74-8.4 18.75-18.75v-3.12c0-10.36-8.4-18.75-18.75-18.75s-18.75 8.39-18.75 18.75V50c.01 10.35 8.4 18.74 18.75 18.75M28.12 46.87c0-6.9 5.6-12.5 12.5-12.5s12.5 5.6 12.5 12.5v3.12c0 6.9-5.6 12.5-12.5 12.5s-12.5-5.6-12.5-12.5z",
    style: {
      fill: "url(#recipients-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 40.62c10.35-.01 18.74-8.4 18.75-18.75v-3.13C93.75 8.39 85.36-.01 75-.01S56.25 8.38 56.25 18.74v3.13c.01 10.35 8.4 18.74 18.75 18.75M62.5 18.75c0-6.9 5.6-12.5 12.5-12.5s12.5 5.6 12.5 12.5v3.13c0 6.9-5.6 12.5-12.5 12.5s-12.5-5.6-12.5-12.5z",
    style: {
      fill: "url(#recipients-01_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 40.62c10.35-.01 18.74-8.4 18.75-18.75v-3.13c0-10.35-8.39-18.75-18.75-18.75s-18.75 8.39-18.75 18.75v3.13c.01 10.35 8.4 18.74 18.75 18.75m-12.5-21.87c0-6.9 5.6-12.5 12.5-12.5s12.5 5.6 12.5 12.5v3.13c0 6.9-5.6 12.5-12.5 12.5s-12.5-5.6-12.5-12.5z",
    style: {
      fill: "url(#recipients-01_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.38 71.88h-37.5c-8.62.01-15.61 7-15.62 15.62v42.19c0 6.04 4.9 10.94 10.94 10.94 1.68 0 3.26-.41 4.69-1.09v51.09h6.25V100h-6.25v29.69a4.69 4.69 0 0 1-9.38 0V87.5c0-5.18 4.2-9.38 9.38-9.38h37.5c2.28 0 4.49.83 6.2 2.34l4.14-4.69a15.63 15.63 0 0 0-10.34-3.91Z",
    style: {
      fill: "url(#recipients-01_svg2__l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.13 100h6.25v90.63h-6.25z",
    style: {
      fill: "url(#recipients-01_svg2__m)"
    }
  }));
};
export default SvgRecipients01;